import React from "react";
import { IListViewField } from "src/components/Shared/ILIstViewField";
import { DocumentListViewDefaultToolbarButtons } from "src/components/Shared/ListViews/DocumentListViewDefaultToolbarButtons";
import { DocumentListViewToolbar } from "src/components/Shared/ListViews/DocumentListViewToolbar";
import { ListView } from "src/components/Shared/ListViews/ListView";
import { ListviewToolbarMoreActions } from "src/components/Shared/ListViews/ListviewToolbarMoreActions";
import { AppEntities } from "src/config/entities";


const IncomingBanksList = () => {
  const fields: IListViewField[] = [
    {
      title: "Company",
      fieldName: "companyName"
    },
    {
      title: "Vendor",
      fieldName: "vendorCustomerName"
    },
    {
      title: "Currency",
      fieldName: "currencyName"
    },
    {
      title: "division",
      fieldName: "divisionName"
    },
    {
      title: "Payment Request",
      fieldName: "baseDocumentAtPresentationName"
    },
    {
      title: "Amount",
      fieldName: "amount"
    }
  ];
  return (
    <>
      <ListView fields={fields} entity={AppEntities.IncomingBanks} createMoreActions={[]}>
        <DocumentListViewToolbar>
          <DocumentListViewDefaultToolbarButtons />
          <ListviewToolbarMoreActions />
        </DocumentListViewToolbar>
      </ListView>{" "}
    </>
  );
};

export default IncomingBanksList;
